<template>
    <div class="telephone-group input-group">
        <select-scroll :options="countries" label="label" selected-label="dialCode" v-model="selected" @input="updateInput" :disabled="this.disabled"></select-scroll>
        <input type="hidden" :name="name + '[country_code]'" id="phone-dial" :value="dialCode">
        <input type="tel" :name=" name + '[national_number]'" id="national-number" :placeholder="placeholder" :value="value.national_number" @input="updateInput()" maxlength="50" required ref="national" :disabled="this.disabled">
    </div>
</template>

<script>
    import SelectScroll from '../SelectScroll.vue';
    import countries from './countries';

    export default {
        name: "TelephoneInput",

        components : {
            SelectScroll
        },

        props: {
            'placeholder' : {
                type: String
            },
            'disabled' : {
                type: Boolean,
                required: false
            },
            'value' : {
                type: Object
            },
            'name': {
                type: String,
                required: false,
                default: 'telephone_number'
            }
        },

        data() {
            return {
                countries,
                selected: 229, // ID for United Kingdom in countries.js array
            }
        },

        methods: {
            updateInput() {
                this.$emit('input', {
                    country_code : this.dialCode,
                    national_number : this.$refs.national.value
                });
            },


        },

        computed: {
            dialCode: function () {
                return this.$data.countries[this.$data.selected].dialCode;
            }
        }

    }
</script>
